import Tippy from '@tippyjs/react'
import React from 'react'
import styled, { css } from 'styled-components'
import { Text } from 'lib/Text'

const Container = styled.div<{ $fill?: boolean }>`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin-bottom: var(--spacing);
  ${(props) =>
    props.$fill &&
    css`
      flex-basis: 100%;
      flex-grow: 1;
    `}
`

const Hint = styled(Text)`
  margin-top: 3px;
`

const Optional = styled(Text)`
  margin-left: 4px;
  vertical-align: middle;
`

interface Props {
  children: React.ReactNode
  className?: string
  fill?: boolean
  label?: string
  hint?: React.ReactNode | string
  useLabelTag?: boolean
  required?: boolean
  optional?: boolean
  onClick?: () => void
}

export const FormField = ({ children, className, hint, fill, label, useLabelTag = true, required, optional, onClick }: Props) => (
  <Container className={className} onClick={onClick} $fill={fill}>
    <Text as={useLabelTag ? 'label' : 'div'} weight="medium" size="ps" color="black-100">
      {label}
      {optional && (
        <Optional size="small" as="span" color="black-40">
          optional
        </Optional>
      )}
      {required && (
        <Tippy content="Required">
          <span>*</span>
        </Tippy>
      )}
      {children}
    </Text>
    {hint && (
      <Hint weight="regular" size="small" color="black-60">
        {hint}
      </Hint>
    )}
  </Container>
)
